import gql from 'graphql-tag'

export default gql`
  query suggestedItemKeywords($keyword: String!) {
    suggestedItemKeywords(keyword: $keyword) {
      type
      keyword
    }
  }
`
